export const userSelector = (state: any) => state.auth.user;
export const schoolSelector = (state: any) => state.auth.school;
export const isAuthenticatedSelector = (state: any) =>
  state.auth.isAuthenticated;
